import { render, staticRenderFns } from "./FaqPrebidPartner.vue?vue&type=template&id=ad1d3ea8&"
import script from "./FaqPrebidPartner.vue?vue&type=script&lang=js&"
export * from "./FaqPrebidPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports